__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-player-view/v8_24_4/";